import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth";
import { useState } from "react";
import { colors } from "@/lib/colors";
import { FaMicrosoft } from "react-icons/fa";

export default function Login() {
    const { login } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const handleMicrosoftLogin = async () => {
        try {
            setIsLoading(true);
            login();
        } catch (error) {
            // Remove console.error statements
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#5a8ba7]/10 to-[#4b4f54]/10 flex flex-col items-center pt-24 gap-8">
            <div className="flex justify-center">
                <img
                    src="/Unbridled-Logo_4C.png"
                    alt="Unbridled Logo"
                    className="w-[32rem] h-auto"
                />
            </div>
            <div className="w-full max-w-md p-8 bg-white rounded-xl shadow-sm">
                <div className="flex flex-col space-y-6 w-full">
                    <div className="text-center">
                        <h2 className="text-2xl font-semibold mb-6" style={{ color: colors.unbridledBlue }}>Welcome to RRAE</h2>
                        <p className="mb-8" style={{ color: colors.unbridledGray }}>Sign in with your Microsoft account to continue</p>
                        <Button
                            onClick={handleMicrosoftLogin}
                            className="w-full flex items-center justify-center gap-2 py-6 hover:opacity-90 hover:scale-[1.02]"
                            style={{
                                backgroundColor: colors.unbridledBlue,
                                transition: 'all 0.2s ease-in-out'
                            }}
                            disabled={isLoading}
                        >
                            <FaMicrosoft className="w-5 h-5" />
                            {isLoading ? "Signing in..." : "Sign in with Microsoft"}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
} 